import { AppState } from '../root.reducer';

export const getIntegratorIds = (state: AppState) => state.internalTeamMember.results;
export const getInternalTeamMembers = (state: AppState) =>
  state.internalTeamMember.results.map((i) => state.entities.internalTeamMember[i]);
